const randomString = (salt = '') =>
    Array.from({ length: 10 }, () => String.fromCharCode(65 + Math.floor(Math.random() * 26))).join('') +
    Date.now() +
    salt

export default randomString
